import { Outlet } from 'react-router-dom';

export const ConsumerApp = () => {
  return <Outlet />;
};
